import { useDispatch, useSelector } from "react-redux"
import { setOnboardingState } from "../state/index.js"
import api from "../api.js"

export const useOnboardingStep = () => {
    const dispatch = useDispatch();
    const onboardingStep = useSelector((state) => state.onboardingStep);

    const updateOnboardingStep = (step, sync = true) => {
        const previousStep = onboardingStep;

        dispatch(setOnboardingState({ onboardingStep: step }));

        if(sync)
        api.post("/auth/update-onboarding-step", { onboardingStep: step }).catch(() => {
            dispatch(setOnboardingState({ onboardingStep: previousStep }));
        });
    };

    return { updateOnboardingStep };
};